import { render, staticRenderFns } from "./service.vue?vue&type=template&id=a922ef06&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"
import style0 from "./service.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports